import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";

const routes = [
  {
    path: "/",
    name: "Login",
    component: () => import("@/views/login/LoginView.vue"),
    beforeEnter(to, from, next) {
      const project = to.query.project;

      if (project !== undefined) {
        store.commit("setCurrentProject", project);
      }
      next();
    }
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("@/views/home/HomeView.vue")
  },
  {
    path: "/insights",
    name: "Insights",
    component: () => import("@/views/home/InsightsView.vue")
  },
  {
    path: "/sales",
    name: "Sales",
    component: () => import("@/views/sale/SalesView.vue")
  },
  {
    path: "/order/:id",
    name: "Order",
    component: () => import("@/views/sale/OrderView.vue")
  },
  {
    path: "/wallet",
    name: "Wallet",
    component: () => import("@/views/home/WalletView.vue")
  },
  {
    path: "/employees",
    name: "Employees",
    component: () => import("@/views/home/EmployessView.vue")
  },
  {
    path: "/delivery",
    name: "Delivery",
    component: () => import("@/views/delivery/DeliveryView.vue")
  },
  {
    path: "/support",
    name: "Support",
    component: () => import("@/views/home/SupportView.vue")
  },
  {
    path: "/settings",
    name: "Settings",
    component: () => import("@/views/home/SettingsView.vue")
  },
  // Página do SC Maxx
  {
    path: "/sc-maxx",
    name: "SCMaxx",
    component: () => import("../views/maxx/ScMaxx.vue")
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/home"
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  }
});

router.beforeEach(async (to, from, next) => {
  const routeName = to.name?.toLowerCase();
  const session = store.getters.getSession;

  if (!session) {
    if (routeName === "login") {
      next();
    } else {
      next({ name: "Login" });
    }
  } else {
    const result = await store.dispatch("getSessionData");

    if (!result.success) {
      next({ name: "Login" });
    }

    const stores = store.getters.getStores;
    const selectedSaleId = store.getters.getSelectedSaleId;

    if (!stores) {
      const loadedStores = await store.dispatch("loadStores");

      if (!loadedStores.success) {
        store.commit("setSession", null);
        next({ name: "Login" });
      }
    }

    if (routeName === "order") {
      if (selectedSaleId) {
        await store.dispatch("loadSale");
        next();
      } else {
        next({ name: "Sales" });
      }
    } else {
      next();
    }
  }
});

export default router;
